import React, { createContext, useContext, useState } from 'react';

const GlobalStateContext = createContext();

export const useGlobalState = () => {
    return useContext(GlobalStateContext);
}

export const GlobalStateProvider = ({ children }) => {
    const [uuid, setUUID] = useState('');

    return (
        <GlobalStateContext.Provider value={{ 
            uuid, setUUID
        }}>
            {children}
        </GlobalStateContext.Provider>
    )
}